/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Add_ContentInputs */

const en_home_v2_add_content = /** @type {(inputs: Home_V2_Add_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Document`)
};

const es_home_v2_add_content = /** @type {(inputs: Home_V2_Add_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir documento`)
};

/**
* | output |
* | --- |
* | "Add Document" |
*
* @param {Home_V2_Add_ContentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_add_content = /** @type {((inputs?: Home_V2_Add_ContentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Add_ContentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_add_content(inputs)
	return en_home_v2_add_content(inputs)
});